export var Mode;
(function (Mode) {
    Mode[Mode["character"] = 0] = "character";
    Mode[Mode["tag"] = 1] = "tag";
    Mode[Mode["whitespace"] = 2] = "whitespace";
    Mode[Mode["number"] = 3] = "number";
    Mode[Mode["entity"] = 4] = "entity";
})(Mode || (Mode = {}));
export var Action;
(function (Action) {
    Action[Action["equal"] = 0] = "equal";
    Action[Action["delete"] = 1] = "delete";
    Action[Action["insert"] = 2] = "insert";
    Action[Action["none"] = 3] = "none";
    Action[Action["replace"] = 4] = "replace";
})(Action || (Action = {}));
//# sourceMappingURL=types.js.map